import React from "react";
import Header from "../components/Header";
import Banner from "../components/Banner";
import WorldClocks from "../components/WorldClocks";
import Prices from "../components/Prices";
import AboutUs from "../components/AboutUs";
import Converter from "../components/Converter";
import Footer from "../components/Footer";
import Social from "../components/Social";
import Charts from "../components/Charts";
import UniRatesMotion from "../components/UniRatesMotion";
import AnnouncementBar from "../components/AnnouncementBar";

const HomePage = ({
  currencies,
  coins,
  exchangeData,
  nimaiis,
  uniPrices,
  viewsData,
  announcement
}) => {
  return (
    <div className="home-page">
      <UniRatesMotion uniPrices={uniPrices} />
      <Banner currencies={currencies} coins={coins} viewsData={viewsData} />
      <WorldClocks />
      <Prices currencies={currencies} coins={coins} nimaiis={nimaiis} />
      <AboutUs exchangeData={exchangeData} />
      <Converter currencies={currencies} coins={coins} />
      <Charts currencies={currencies} coins={coins} />
      <Social exchangeData={exchangeData} />

      
      {/* Floating announcement */}
      <AnnouncementBar announcement={announcement} />
    </div>
  );
};

export default HomePage;
